// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__6svi1","productName":"Table_productName__315Mg"};